export function previewHost(customHost: string) {
    let host = inwink.config.companionPreviewUrl;
    if (customHost) {
        host = customHost;
    }

    if (!host.startsWith("https://") && !host.startsWith("http://")) {
        host = "https://" + host;
    }

    if (!host.endsWith("/")) {
        host = host + "/";
    }
    return host;
}


